import axios from "axios";
import { Constants } from "../utils/Constants";

export function getRelatorioConsumo() {
    return axios.get(`${Constants.baseUrl}/financeiro/relatorio-consumo`);
}

export function getDadosPagamento() {
    return axios.get(`${Constants.baseUrl}/financeiro/dados`);
}

export function updateDadosPagamento(payload) {
    return axios.patch(`${Constants.baseUrl}/financeiro/dados`, payload);
}

export function cancelPlan(payload) {
    return axios.post(`${Constants.baseUrl}/financeiro/cancelar`, payload);
}
